import {ea, emptyArray} from "js-vextensions";
import {CreateAccessor, GetDoc, GetDocs} from "mobx-graphlink";
import {User} from "./users/@User";
import {TagTargetGroup} from "../Commands/UserCommands.js";

export const MeID = CreateAccessor({ctx: 1}, function(): string|n {
	return this.graph.userInfo?.id;
});
export const Me = CreateAccessor(()=>{
	return GetUser(MeID());
});

export const GetUser = CreateAccessor((userID: string|n): User|n=>{
	return GetDoc({}, a=>a.users.get(userID!));
});
export const GetUsers = CreateAccessor((): User[]=>{
	return GetDocs({}, a=>a.users) ?? ea;
});

export const GetSelectedUserID = CreateAccessor({ctx: 1}, function() {
	return this.store.main.more.users.selectedUserID;
});
export const GetSelectedUser = CreateAccessor(()=>{
	const selectedID = GetSelectedUserID();
	return GetDoc({}, a=>a.users.get(selectedID!));
});

// NOTE: The "entity" here is meant generically; it's not the "entities" collection in the database.
export const GetUserEntityTagCounts = CreateAccessor((entityGroup: TagTargetGroup, entityID: string|n)=>{
	/*const usersWithEntityTags = GetDocs({
		queryOps: [new WhereOp(`entityTags.${entityGroup}.${entityID}`, ">", "")],
	}, a=>a.users);*/
	const usersWithEntityTags = GetUsers().filter(a=>a.entityTags?.[entityGroup]?.[entityID as any] != null);

	const tagCounts = {} as {[key: string]: number};
	for (const user of usersWithEntityTags) {
		const userEntityTags = user.entityTags[entityGroup][entityID as any];
		for (const tag of userEntityTags) {
			tagCounts[tag] = (tagCounts[tag] ?? 0) + 1;
		}
	}
	return tagCounts;
});
export const GetUserEntityTags = CreateAccessor((userID: string|n, entityGroup: TagTargetGroup, entityID: string|n)=>{
	const user = GetUser(userID);
	return user?.entityTags?.[entityGroup]?.[entityID as any] ?? emptyArray;
});